<template>
<!--  复制链接显示轨迹-->
  <div class="track_id">
    <div class="head_css marTop15" v-show="!quickItem.length">
      <div class="track_detail color26 XYcenter" style="min-height: 400px">
        暂无查询数据
      </div>
    </div>
    <div class="head_css marTop15" v-for="(item,index) in quickItem" :key="index">
      <div class="quick_query_head" @click="showChange(index)">
        <div class="flex">
          <div class="infoTit marRight100">轨迹组关联数据{{item.trackingNo}}</div>
          <div class="quick_query_head_line marRight100">{{filterCarriers(item.carrierCode)}}</div>
          <div class="state_tag marRight100" :class="classObject(item.trackingStatus)">{{searchResultFilter(item.trackingStatus)}}</div>
        </div>
        <div class="flex quick_query_head_line marLeft15 color26">
          <div class="pointer flex">
            <span v-show="item.spreadShow" class="whiteSpace">{{$t('page.hide_list')}}</span>
            <span v-show="!item.spreadShow" class="whiteSpace">{{$t('page.show_list')}}</span>
            <span class="workbench_icon">
              <i class="el-icon-arrow-up" :class="{'transform180': !item.spreadShow, 'transform0': item.spreadShow}"></i>
            </span>
          </div>
        </div>
      </div>
      <el-collapse-transition>
        <div v-if="item.spreadShow">
          <quick-detail
            :detail="item"
            :index="index">
          </quick-detail>
        </div>
      </el-collapse-transition>
    </div>
  </div>
</template>

<script>
import {trackingGroupId} from '@/api/getSearch.js'
import quickDetail from './trackIdDetail.vue'
import LocalStorage from '@/common/localStorage.js'
export default {
  components: {
    quickDetail
  },
  data () {
    return {
      stateItem: [
        {name: '等待查询', state: 'Pending', num: 0},
        {name: '查询不到', state: 'NotFound', num: 0},
        {name: '预报发货', state: 'InfoReceived', num: 0},
        {name: '运输途中', state: 'InTransit', num: 0},
        {name: '到达待取', state: 'ArrivedDelivery', num: 0},
        {name: '派送途中', state: 'Delivering', num: 0},
        {name: '成功派送', state: 'Delivered', num: 0},
        {name: '投递失败', state: 'DeliveryFailure', num: 0},
        {name: '包裹退回', state: 'Return', num: 0},
        {name: '包裹异常', state: 'Exception', num: 0},
      ],
      quickItem: [],
    }
  },
  created () {
    let query = this.GetQueryString()
    if (query) {
      trackingGroupId(query)
        .then((res) => {
          res['spreadShow'] = true
          this.quickItem.push(res)
        })
    }
  },
  mounted(){
    if (this.quickItem) this.$emit('toSroll')
  },
  methods: {
    GetQueryString () {
      let url = window.location.href
      if (url.indexOf('?') !== -1) {
        let str = url.substr(1)
        let strs = str.split('=')
        return (strs[1])
      } else {
        return null
      }
    },
    showChange (index) {
      this.$set(this.quickItem[index], 'spreadShow', !this.quickItem[index].spreadShow)
    },
    filterCarriers (code) {
      let text = ''
      let vm = this
      LocalStorage.get('carriers').map(function (item) {
        if (code === item.code) {
          if (vm.$i18n.locale==='zh-cn'){
            text = item.zhName
          }
          if (vm.$i18n.locale==='en'){
            text = item.enName
          }
        }
      })
      return text
    },
    searchResultFilter (code) {
      switch (code) {
        case 'Pending':
          return '等待查询'
        case 'NotFound':
          return '查询不到'
        case 'InfoReceived':
          return '预报发货'
        case 'InTransit':
          return '运输途中'
        case 'ArrivedDelivery':
          return '到达待取'
        case 'Delivering':
          return '派送途中'
        case 'Delivered':
          return '成功派送'
        case 'DeliveryFailure':
          return '投递失败'
        case 'Return':
          return '包裹退回'
        case 'Exception':
          return '包裹异常'
      }
    },
    classObject (code) {
      switch (code) {
        case 'Pending':
          return 'back26'
        case 'NotFound':
          return 'backF2'
        case 'InfoReceived':
          return 'backW'
        case 'InTransit':
          return 'backW'
        case 'ArrivedDelivery':
          return 'backG2'
        case 'Delivering':
          return 'back26'
        case 'Delivered':
          return 'backG2'
        case 'DeliveryFailure':
          return 'backF2'
        case 'Return':
          return 'backF2'
        case 'Exception':
          return 'backF2'
      }
    },
  }
}
</script>

<style>
.quick_query {
  height: calc(100vh - 150px);
  /*overflow: auto;*/
}
.quick_query_head {
  display: flex;
  justify-content: space-between;
}
.workbench_icon {
  width: 16px;
  height: 40px;
  line-height: 40px;
  text-align: right;
}
.quick_query_head_line {
  line-height: 40px;
}
.state_tag {
  padding: 0 10px;
  height:20px;
  line-height: 20px;
  color: #ffffff;
  margin: 10px 0;
  border-radius:4px;
  text-align: center;
}
.last_track {
  width: 300px;
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
}
.track_detail {
  padding: 15px 40px;
  background-color: #ffffff;
  /* display: flex;
  justify-content: space-between; */
}
.no_detail {
  height: 32px;
  line-height: 32px;
}
.post_box {
  min-width: 50px;
  padding: 0 10px;
  height: 32px;
  margin: 0 10px;
  /* display: flex; */
  cursor: pointer;
  text-align: center;
  line-height: 32px;
  border-radius: 5px;
}
.post_box:hover {
  background-color: #f7f7f7;
}
</style>



// WEBPACK FOOTER //
// src/components/new/trackId.vue